import { render, staticRenderFns } from "./TimeTable.vue?vue&type=template&id=2b070890&scoped=true&"
import script from "./TimeTable.vue?vue&type=script&lang=js&"
export * from "./TimeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b070890",
  null
  
)

export default component.exports